<template>
  <div class="banner-section">
    <Carousel
      :perPage="1"
      navigationEnabled
      paginationEnabled
      loop
      :centerMode="true"
    >
      <Slide v-if="$route.name === 'Home'">
        <div class="relative">
          <img src="@/assets/images/buyHomeBanner3.png" class="w-full hidden md:block">
          <img src="@/assets/images/buyHomeBannerPhone3.png" class="w-full md:hidden">
          <!-- <a
            class="absolute z-10 bg-green text-white px-10 py-2 rounded-full text-2xl bottom-0 md:m-6 lg:m-16 lg:mt-24 lg:mb-10 block hidden md:block"
            :href="buyhiveHowToBuyLink" target="_blank"
          >
            How to Buy
          </a> -->
          <!-- <div class="md:hidden z-10 absolute text-white top-0 m-5">
            <h2 class="text-xl font-bold">Buy ready-made products <br>from our vetted suppliers</h2>
            <p class="pt-2 pb-5 text-lg">
              Learn how to do<br> it in 4 easy steps
            </p>
            <a
              class=" bg-green rounded-full text-lg inline-block px-8 py-2"
              :href="buyhiveHowToBuyLink" target="_blank"
            >
              How to Buy
            </a>
          </div> -->
        </div>
      </Slide>
      <Slide v-if="$route.name === 'Home'">
        <div class="relative">
          <img src="@/assets/images/buyHomeBanner.png" class="w-full hidden md:block">
          <img src="@/assets/images/buyHomeBannerPhone.png" class="w-full md:hidden">
          <router-link
            class="absolute z-10 bg-green text-white px-10 py-2 rounded-full text-2xl bottom-0 md:m-6 lg:m-16 block hidden md:block"
            to="/contact-us"
          >
            Contact
          </router-link>
          <div class="md:hidden z-10 absolute text-white top-0 m-5">
            <h2 class="text-xl font-bold">Need help sourcing?</h2>
            <p class="pt-2 pb-5 text-lg">
              Contact one of our in-house <br>
              sourcing specialists now
            </p>
            <router-link
              class=" bg-green rounded-full text-lg inline-block px-8 py-2"
              to="/contact-us"
            >
              Contact
            </router-link>
          </div>
        </div>
      </Slide>
    </Carousel>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'BannerSection',
  data() {
    return {
      buyhiveHowToBuyLink: process.env.VUE_APP_BUYHIVE_HOW_TO_BUY,
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    getImg(img) {
      return require(`@/assets/images/${img}`)
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin btn-Carousel {
  @apply w-10 h-10 -mt-5;
  font-size: 0;
  transform: translate(0);
  transition: 0.5s;
  &:hover {
    @apply bg-theme;
    transition: 0.5s;
    &:before {
      transition: 0.5s;
    }
  }
  &:focus {
    @apply outline-none;
  }
  &:before {
    @apply w-4 h-4 absolute border-l border-b border-white;
    content: "";
    top: 12px;
  }
}
.banner-section {
  /deep/.VueCarousel-navigation {
    .VueCarousel-navigation-prev {
      @include btn-Carousel;
      &:before {
        transform: rotate(45deg);
        left: 15px;
      }
    }
    .VueCarousel-navigation-next {
      @include btn-Carousel;
      &:before {
        transform: rotate(-135deg);
        right: 15px;
      }
    }
  }
  @media screen and (max-width: 765px) {
    @apply pb-5;
    /deep/.VueCarousel-navigation {
      display: none;
    }
    /deep/.VueCarousel-pagination {
      .VueCarousel-dot-container {
        margin-top: 0px !important;
      }
      button.VueCarousel-dot {
        margin-top: 10px !important;
      }
      display: inline;
    }
   
  }
  @media screen and (min-width: 765px) {
    /deep/.VueCarousel-pagination {
      display: none;
    }
    /deep/.VueCarousel-navigation {
      display: inline;
    }
  }
}
</style>
